import { render } from "./TicketMarquee.vue?vue&type=template&id=3e95e91c"
import script from "./TicketMarquee.vue?vue&type=script&lang=js"
export * from "./TicketMarquee.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__